import { StringParser } from '@internetarchive/field-parsers';
import { MetadataField } from '../metadata-field';
export class StringField extends MetadataField {
    constructor(rawValue) {
        super(StringParser.shared, rawValue);
    }
}
//# sourceMappingURL=string.js.map